<script setup lang="ts">
import { onMounted } from 'vue'

interface Props {
  id: string
  message: string
  type: 'info' | 'warning' | 'error'
}

// Remove type from withDefaults since we want ToastContainer to handle the default
const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'close', id: string): void
}>()

const getTypeStyles = () => {
  switch (props.type) {
    case 'info':
      return { icon: 'ℹ️', bgColor: 'bg-blue-50 dark:bg-blue-900/50', borderColor: 'border-blue-200 dark:border-blue-800' }
    case 'warning':
      return { icon: '⚠️', bgColor: 'bg-yellow-50 dark:bg-yellow-900/50', borderColor: 'border-yellow-200 dark:border-yellow-800' }
    case 'error':
      return { icon: '❌', bgColor: 'bg-red-50 dark:bg-red-900/50', borderColor: 'border-red-200 dark:border-red-800' }
  }
}

onMounted(() => {
  // Auto close after 10 seconds
  setTimeout(() => {
    emit('close', props.id)
  }, 10000)
})
</script>

<template>
  <div 
    class="w-96 p-4 rounded-lg shadow-lg border animate-slide-in"
    :class="[getTypeStyles().bgColor, getTypeStyles().borderColor]"
  >
    <div class="flex items-start gap-3">
      <!-- Icon -->
      <div class="text-xl">{{ getTypeStyles().icon }}</div>

      <!-- Content -->
      <div class="flex-1">
        <p class="text-sm text-gray-800 dark:text-gray-200">
          {{ message }}
        </p>
      </div>

      <!-- Close Button -->
      <button 
        @click="$emit('close', id)"
        class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
      >
        ✕
      </button>
    </div>
  </div>
</template>

<style scoped>
.animate-slide-in {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>